export const RES_SIDEPAGE_MAP = {
  server: 'VmInstanceSidePage',
  cloudaccount: 'CloudaccountSidePage',
}
